import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TableRowsIcon from '@mui/icons-material/TableRows';
import { ROLES } from '../auth/roles';
import { hasRoleOrGroup } from '../auth/access';

// Cada item do menu lista quais roles podem vê-lo. allow: [] libera o item
// pra qualquer usuário autenticado (mesmo sem role/grupo nenhum) — é o caso
// de "/configUser", que atende admin/dev/user/visualizador e também quem
// não tem role nenhuma (modo somente-leitura, ver ConfigUserService).
const ITENS_MENU = [
  { href: "/config", label: "Config", icon: <ManageAccountsIcon />, allow: [ROLES.DEV] },
  { href: "/configUser", label: "Config Novo", icon: <ManageAccountsIcon />, allow: [] },
  { href: "/board", label: "Dash Board", icon: <DashboardIcon />, allow: [ROLES.DEV] },
  { href: "/lista", label: "Lista", icon: <TableRowsIcon />, allow: [ROLES.DEV] },
];

export default function MenuLateral() {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, left: open });
  };

  const itensVisiveis = ITENS_MENU.filter(
    (item) => item.allow.length === 0 || item.allow.some((role) => hasRoleOrGroup(role))
  );

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {itensVisiveis.map((item) => (
          <ListItem button component="a" href={item.href} key={item.href}>
            <ListItemIcon>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <IconButton
      size="large"
      edge="start"
      color="inherit"
      aria-label="open drawer"
      sx={{ mr: 2 }}
      onClick={toggleDrawer('left', !state['left'])}
    >
      <MenuIcon />
      <Drawer
        anchor={'left'}
        open={state['left']}
        onClose={toggleDrawer('left', false)}
      >
        {list('left')}
      </Drawer>
    </IconButton>
  );
}
